import Lookup from 'src/componentes/select2';

const TratamentoRiscoLookup = ({ ...rest }) => (
  <Lookup
    labelKey="nome"
    valueKey="id"
    url="/TratamentoRiscoLookup"
    clearable={false}
    {...rest}
  />
);

export default TratamentoRiscoLookup;
